import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { opponentPageConfig } from "./opponentPageConfig";

export const opponentRecordDefinition: RecordDefinition = {
  path: "/opponent",
  entityName: "dwopponent",
  listRoute: "/opponents",
  backTitle: "Back to opponents",
  allowedRoles: administratorRoles,
  config: opponentPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Opponent",
    newRecordTitle: "New Opponent",
  },
};
